module.exports = __webpack_public_path__ + "static/media/19ESCAP48.a9809cc4.jpg";